import ModalBody from '../../atoms/ModalBody';
import ModalFotterCloseButton from '../../molecules/ModalFotterCloseButtonComponent';

import PropTypes from 'prop-types';
import React from 'react';
import { Modal } from 'react-bootstrap';

class CompleteModal extends React.Component {
  static get propTypes() {
    return {
      show: PropTypes.bool,
      onClick: PropTypes.func,
    };
  }

  render() {
    return (
      <Modal show={this.props.show}>
        <ModalBody>
          <p className="text-center">正常に登録が行われました。</p>
        </ModalBody>
        <ModalFotterCloseButton
          closeButtonTitle="閉じる"
          onClick={this.props.onClick}
        />
      </Modal>
    );
  }
}

export default CompleteModal;
